import { z } from "zod";
import { USER_ROLE_VALUES } from "../../constants/user-role.js";
export const adminUsersQuerySchema = z.object({
    query: z.string().optional(),
    limit: z.coerce.number().int().positive().optional(),
    cursor: z.coerce.number().int().nonnegative().optional(),
});
export const AdminUserSchema = z.object({
    id: z.uuid(),
    email: z.email(),
    displayName: z.string(),
    role: z.enum(USER_ROLE_VALUES),
    level: z.number().int().nonnegative(),
    createdAt: z.string(),
});
export const AdminUserListSchema = z.object({
    users: z.array(AdminUserSchema),
});
